import { displayToast } from '~/utils/toast'

export const copyText = (value?: string | null, message?: string): void => {
  if (value && !!navigator.clipboard) {
    navigator.clipboard.writeText(value)
    displayToast(message || 'Copied to clipboard', 'success')
  }
}

export const navigatorSupported = !!navigator.clipboard
